import { render, staticRenderFns } from "./page_owner.vue?vue&type=template&id=393f8ed2&scoped=true&"
import script from "./page_owner.vue?vue&type=script&lang=js&"
export * from "./page_owner.vue?vue&type=script&lang=js&"
import style0 from "./page_owner.vue?vue&type=style&index=0&id=393f8ed2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393f8ed2",
  null
  
)

export default component.exports